module.exports = __webpack_public_path__ + "static/media/pgo67ws.ef2e77cd.pdf";